import React from 'react';
import * as iconMap from '@icons/menuCategories';

interface MainCategoryIconProps {
  id?: string;
  className?: string;
  darkMode?: boolean;
}

const MainCategoryIcon = ({ id = 'Mains', ...props }: MainCategoryIconProps) => {
  const Icon = iconMap[id] || iconMap.Mains;
  return <Icon {...props} />;
};

export default MainCategoryIcon;
